





















































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import TopNavigationComponent from "./Components/TopNavigation.vue";
import TechnicalApplicationComponent from "./Components/TechnicalApplication.vue";
import ApplicationBudgetComponent from "./Components/ApplicationBudget.vue";
import DueDeligenceComponent from "./Components/DueDeligence.vue";
import LogframeworkComponent from "./Components/Logframework.vue";
import SafeguardComponent from "./Components/SafeGuard.vue";
import GenericComponent from "./Components/Generic.vue";
import DocumentChecklistComponent from "./Components/DocumentChecklist.vue";
import ButtonPanelComponent from "./Components/ButtonPanel.vue";
import { Workspace, ApplicationSubmit } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";

const namespace: string = "application";

@Component({
  components: {
    TopNavigationComponent,
    TechnicalApplicationComponent,
    ApplicationBudgetComponent,
    DueDeligenceComponent,
    LogframeworkComponent,
    GenericComponent,
    DocumentChecklistComponent,
    ButtonPanelComponent,
    SafeguardComponent
  }
})
export default class ReadonlyApplicationFormComponent extends Vue {
  @State(namespace) application!: Workspace;
  @Action("getTemplate", { namespace }) getTemplate: any;
  @Action("getApplication", { namespace }) getApplication: any;
  @Action("updateLanguage", { namespace }) updateLanguage: any;
  @Action("updateTopMenu", { namespace: "application" }) updateMenu: any;
  @Action("updateSubMenu", { namespace }) updateSubMenu: any;
  @Action("getFeedbackInfo", { namespace: "feedback" }) getFeedbackInfo: any;
  @Action("saveApplication", { namespace: "application" }) save: any;
  @Action("saveAppData", { namespace: "application" }) saveAppData: any;
  @Getter("rootTemplate", { namespace }) schema: any;
  @Getter("topMenu", { namespace }) topMenu: string;
  @Getter("subMenu", { namespace }) subMenu: string;
  @Getter("projectTitle", { namespace }) projectTitle: string;
  @Getter("_appUser", { namespace: "RootApp"}) _username!: string;
  @Getter("projectYrs", { namespace: "application" }) years: any;
  @Getter("reportingFrequency", { namespace: "application" }) reportingFreq: any;
  @Getter("appSubmit", { namespace }) appSubmit: ApplicationSubmit;

  $refs: {
    technicalApp: TechnicalApplicationComponent;
    appBudget: ApplicationBudgetComponent;
  };

  /** declare variables */
  isDirty: boolean = false;
  selectedTopMenu: string = "technicalApplication";
  selectedSubMenu: string = "";

  mounted() {
    // update the state
    this.updateLanguage(this.$root.$i18n.locale);
    this.selectedTopMenu =  this.application.selectedItem || this.selectedTopMenu;
    // get the templates..
    // this.getTemplate();
  }

  download() {    
     let applicationData;

switch (this.application.application.BudgetType) {
  case 'Tiger':
    applicationData = {
      ...this.application.data,
      amountOfMatchingFund: this.application.data.applicationBudget.summary.totalBudget.matchFunding || 0
    };
    break;
  case 'CAG':
    applicationData = {
      ...this.application.data,
      fundingRequests: this.application.data.totalProjectBudgect || 0
    };
    break;
  default:
    applicationData = this.application.data;
    break;
}
    this.$services.pdf.generate({
      "entity": "Application",
      "schema": this.schema, 
      "data": applicationData, 
      "currency": this.application.application.BudgetCurrency,
      "user": this._username,
      "id": this.application.application.ApplicationId,
      "type": this.application.templates["IsRAGTemplate"] ? "RAG" : "TSG",
      "code": this.application.application.Code,
      "years":this.years,
      "Quaters":this.reportingFreq,
      "checklist": this.appSubmit.checklist,
      "logSchema": this.application.logSchema
    });
  }

  /** update the selected key on top menu selection */
  topMenuChanged(key) {
    this.selectedTopMenu = key;
  }

  /** update the sub menu key */
  subMenuChanged(menu) {
    this.updateSubMenu(menu);
  }


  /** set is-dirty flag  */
  setDirtyFlag(flag) {
    this.isDirty = flag;
  }

  /** back to proposals page */
  back() {
    
    this.$router.push({
      name: "applSummary",
      params: { applicationId: this.application.application.ApplicationId.toString() }
    });
  }

  /** get child schema properties to populate the left panel*/
  get subSchema(): any {
    if (this.schema && this.schema.properties) {
      // Set style if the template doesn't have x-class property
      for (let pKey in this.schema.properties) {
        if (this.schema.properties[pKey]) {
          for (let cKey in this.schema.properties[pKey].properties) {
            if (_app.templateSections[cKey]&& !this.schema.properties[pKey].properties[cKey]["x-class"]) {
              this.schema.properties[pKey].properties[cKey]["x-class"] = _app.templateSections[cKey]["x-class"];
            }
          }
        }
      }

      return this.schema.properties[this.selectedTopMenu];
    } else {
      return {};
    }
  }

  /*** Watch methods */
  @Watch("selectedTopMenu")
  onMenuChanges(value: any, oldvalue: any) {
    this.updateMenu(value);
    this.$router.push({
      name: "viewApplication",
      params: { appId: this.application.application.ApplicationId.toString(), section: value } 
    });
  }
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any, previousRoute) {
    if (changedRoute && changedRoute.name === 'viewApplication') {
      //this.selectedTopMenu =  this.application.selectedItem;
      if (changedRoute.params.section) {
        this.selectedTopMenu = changedRoute.params.section;
      }

      if (!previousRoute || previousRoute.name !== changedRoute.name || changedRoute.params.appId !== previousRoute.params.appId) {
        const applicationId = changedRoute.params.appId;
        this.getApplication(applicationId);
        this.getFeedbackInfo({ entity: 'Application', transactionId: applicationId });
      }
      // this.update += 1;
    }
  }

  viewConceptNote() {
    let routeData = this.$router.resolve({
      name: "viewConceptNote",
      params: { conceptNoteId: this.application.application.ConceptNoteId.toString(), section: 'technicalApplication' },
    });

    window.open(routeData.href, "_blank");
  }
}
